import { Component, ElementRef, Input, ViewChild } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { CheckoutDesktopModalComponent } from "../../modals/checkout-desktop/checkout-desktop-modal.component";
import { SettingService } from "src/app/shared/services/setting.service";

@Component({
    selector: "desktop-checkout",
    templateUrl: "./desktop-checkout.component.html",
    styleUrls: ["./desktop-checkout.component.scss"],
    standalone: false
})
export class DesktopCheckout{
                
  constructor(private modalCtrl: ModalController, public setting: SettingService, private element: ElementRef){}
  @ViewChild('checkoutComponent') checkoutComponent!: CheckoutDesktopModalComponent;
  @Input() order;
  @Input() store;
  @Input() checkTwoForOneDiscounts: Function;
  
  ngOnInit() {
    if(this.setting.configuration.uIoptions.checkoutIconTextColor) {
      this.setupColorsToScss();
    }
  } 

  setupColorsToScss() {
    const hostElement = this.element.nativeElement;
    const host = hostElement;
    host.style.setProperty('--icon-txt-color', this.setting.configuration.uIoptions.checkoutIconTextColor);
  }

  async cancel() {
    await this.modalCtrl.dismiss(null);
  }

  loadProfile(){
    this.checkoutComponent.loadProfile();
  }
}
